<template>
    <div class="card d-flex flex-row align-items-center p-3 shadow-sm" style="max-width: 400px;">
      <!-- Profile Picture -->
      <div class="me-3">
        <img :src="profilePhoto" alt="Profile Photo" class="rounded-circle border border-primary" />
      </div>
      <!-- Profile Info -->
      <div>
        <h5 class="mb-1">{{ firstName }} {{ lastName }}</h5>
        <p class="text-muted mb-0">{{ email }}</p>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    data() {
      return {
        profilePhoto: localStorage.getItem("profile_photo_url") || require("@/assets/ProfileSample/Profile Pictures B.png"), // Default image if not available
        firstName: localStorage.getItem("first_name") || "John",
        lastName: localStorage.getItem("last_name") || "Doe",
        email: localStorage.getItem("email") || "john.doe@example.com",
      };
    },
  };
  </script>
  
  <style scoped>
  .rounded-circle {
    width: 150px;
    height: 150px;
    padding: 5px;
    max-width: 100%; /* Ensure it scales within the container */
    border-radius: 50%; /* Keep it circular */
    object-fit: contain; /* Show the full image without cropping */
  }
  </style>
  